import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Col } from "react-bootstrap";

import React from "react";
import {
    Box,
    FooterContainer,
    Row,
    Column,
    FooterLink,
    Heading,
} from "./FooterStylesStyleA.js";
 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons"
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons"


const config = require("../constants/constants.js")

const url_customer_image_logo = config.URL_IMAGES_CUSTOMER+"logo-cust"+config.CUSTOMER_CODE+".png";  // logo-cust0001.png 

const FooterComponentStyleA = () => {

    const [tabAttivo, setTabAttivo] = React.useState('home');
    
    const [ragioneSociale, setRagioneSociale] = useState("");                      
    const [email, setEmail] = useState("");                      
    const [linkWhatsapp, setLinkWhatsapp] = useState("");     
    const [linkFacebook, setLinkFacebook] = useState("");     
    const [linkInstagram, setLinkInstagram] = useState("");     
    const [linkTwitter, setLinkTwitter] = useState("");     
    const [linkLinkedin, setLinkLinkedin] = useState("");     
    const [urlSiteImageServer, setUrlSiteImageServer] = useState("");                      
    const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");                      
    
    const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
        console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =",progressivoRagSoc);
        const url = `/api/configs/progressivo/`+progressivoRagSoc;
        const { data } = await axios.get(url);
        return data
    }
         
 useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => { 
        console.log(`data =`, data);  
        setRagioneSociale(data?.ragioneSociale);
        setEmail(data?.email);
        setLinkWhatsapp("https://wa.me/"+data?.linkWhatsapp);
        setLinkFacebook(data?.linkFacebook);
        setLinkInstagram(data?.linkInstagram);
        setLinkTwitter(data?.linkTwitter);
        setLinkLinkedin(data?.linkLinkedin);          
        setUrlSiteImageServer(data?.urlSiteImageServer);
        setUrlCustomerImageServer(data?.urlCustomerImageServer);
        console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);  
        console.log(`data?.linkFacebook =`, data?.linkFacebook);  
        console.log(`data?.linkInstagram =`, data?.linkInstagram);  
        console.log(`data?.linkTwitter =`, data?.linkTwitter);  
        console.log(`ragioneSociale =`, data?.ragioneSociale);  
        console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);  
    })
    .catch((er) => {
        console.log(er);
    });  
 }, [ragioneSociale,setEmail,setUrlCustomerImageServer])


 return (
    <Box>
         <FooterContainer>
            <Row>
                <Column>

                    <Heading
                        style={{
                            color: "#0000008C",
                        }}
                        >Romolo servizi funebri&trade;
                    </Heading>

                    <img src={url_customer_image_logo} alt="bug" width={140} height={100} />       

                </Column>

                <Column>
                    <Heading
                        style={{
                            color: "#0000008C",
                        }}
                        >
                        Sedi
                    </Heading>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >    
                        <b>Terno d'Isola</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>Bonate Sotto</b> 
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        via Trento 13&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;via Trieste 6 
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        romoloangelo@gmail.com
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        P.iva&nbsp;03445450160 
                    </FooterLink>


                </Column>                               

                <Column>

                    <Heading
                        style={{
                            color: "#0000008C",
                        }}
                        >
                        Contattaci
                    </Heading>
                    
                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        tel <b>+39.035.90.40.14</b> 
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        cell 335.21.00.28 
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        cell 339.534.13.45 
                    </FooterLink>

                    <FooterLink 
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        cell 338.481.50.29 
                    </FooterLink>

                </Column>


            {/* 
                <Column>

                    <Heading
                        style={{
                            color: "#0000008C",
                        }}
                        >
                        &nbsp; 
                    </Heading>
                    
                    <FooterLink href="#"
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        created by MPM PROJECT 
                    </FooterLink>

                    <FooterLink
                        style={{
                            color: "#0000008C",
                        }}
                    >
                      WebAgency
                    </FooterLink>

                    <FooterLink href="#"
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        www.mpmproject.it
                    </FooterLink>
 

                    <FooterLink href="/admin/categories"
                        style={{
                            color: "#0000008C",
                            fontStyle: "italic"
                        }}
                        >
                        Login
                    </FooterLink>

                </Column>
           */}

                <Column>
                
                    <Heading
                        style={{
                            color: "#0000008C",
                        }}
                        >
                        Web Social Media
                    </Heading>

                    <row>

                        <FooterLink href={linkFacebook} target="_blank" title="Facebook®">
                            <FontAwesomeIcon icon={faFacebook}  
                                        style={{
                                            marginLeft: "0px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                        <FooterLink href={linkInstagram} target="_blank" title="Instagram®">
                            <FontAwesomeIcon icon={faInstagramSquare}  
                                        style={{
                                            marginLeft: "20px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                        <FooterLink href={linkWhatsapp} target="_blank" title="Whatsapp®">
                            <FontAwesomeIcon icon={faWhatsapp}  
                                        style={{
                                            marginLeft: "20px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                    </row>

                    <FooterLink 
                            style={{
                                color: "#0000008C",
                                fontStyle: "italic",
                                height: "6px"
                            }}
                            >
                            &nbsp;
                    </FooterLink>

                    <FooterLink 
                            style={{
                                color: "#0000008C",
                                fontStyle: "italic"
                            }}
                            >
                            created by MPM PROJECT
                    </FooterLink>

                    <FooterLink href="/admin/categories"
                            style={{
                                color: "#0000008C",
                                fontStyle: "italic"
                            }}
                            >
                            Login
                    </FooterLink>

                </Column>


            </Row>
        </FooterContainer>
 
    </Box>
  );
};


export default FooterComponentStyleA;
